__turbopack_context__.v({
  "content": "TheMorningStar-module-scss-module__7liZFa__content",
  "copy": "TheMorningStar-module-scss-module__7liZFa__copy",
  "image": "TheMorningStar-module-scss-module__7liZFa__image",
  "imageContainer": "TheMorningStar-module-scss-module__7liZFa__imageContainer",
  "inner": "TheMorningStar-module-scss-module__7liZFa__inner",
  "lockup": "TheMorningStar-module-scss-module__7liZFa__lockup",
  "root": "TheMorningStar-module-scss-module__7liZFa__root",
});
